import { atom } from 'jotai';

// キーボードショートカット一覧（チートシート）の開閉状態。
// `?` キー（useGlobalShortcuts）とヘルプメニューが共有する。既定は閉。
export const cheatsheetAtom = atom<boolean>(false);
